var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","item-text":"name","item-value":"name","items":_vm.byCountry,"label":_vm.label,"outlined":"","clearable":_vm.clearable},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }